import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { agreementsApi } from './api/agreementsApi';
import { appConfigApi } from './api/appConfigApi';
import { bugReportApi } from './api/bugReportApi';
import { chatsApi } from './api/chatsApi';
import { communitiesApi } from './api/communitiesApi';
import { exercisesConfigApi } from './api/exerciseConfigAPI';
import { exercisesApi } from './api/exercisesAPI';
import { firebaseApi } from './api/fireBaseStorageApi';
import { notificationsApi } from './api/notificationsApi';
import { paymentApi } from './api/paymentsApi';
import { postsApi } from './api/postsApi';
import { programsApi } from './api/programsAPI';
import { searchApi } from './api/searchApi';
import { subscriptionsApi } from './api/subscriptionsApi';
import { supportApi } from './api/supportApi';
import { trainingsApi } from './api/trainingsAPI';
import { translationsApi } from './api/translationsAPI';
import { userTrainingAccessApi } from './api/userTrainingAccessApi';
import { usersApi } from './api/users/usersApi';
import appStatusReducer from './appStatusSlice';

export const store = configureStore({
  reducer: {
    appStatus: appStatusReducer,
    [agreementsApi.reducerPath]: agreementsApi.reducer,
    [exercisesApi.reducerPath]: exercisesApi.reducer,
    [exercisesConfigApi.reducerPath]: exercisesConfigApi.reducer,
    [translationsApi.reducerPath]: translationsApi.reducer,
    [programsApi.reducerPath]: programsApi.reducer,
    [trainingsApi.reducerPath]: trainingsApi.reducer,
    [userTrainingAccessApi.reducerPath]: userTrainingAccessApi.reducer,
    [communitiesApi.reducerPath]: communitiesApi.reducer,
    [postsApi.reducerPath]: postsApi.reducer,
    [chatsApi.reducerPath]: chatsApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [subscriptionsApi.reducerPath]: subscriptionsApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [firebaseApi.reducerPath]: firebaseApi.reducer,
    [bugReportApi.reducerPath]: bugReportApi.reducer,
    [appConfigApi.reducerPath]: appConfigApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
  },
  // RTK 2: ThunkMiddleware uses old Middleware signature; type assertion required for configureStore compatibility
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      agreementsApi.middleware,
      exercisesApi.middleware,
      exercisesConfigApi.middleware,
      translationsApi.middleware,
      programsApi.middleware,
      trainingsApi.middleware,
      userTrainingAccessApi.middleware,
      communitiesApi.middleware,
      postsApi.middleware,
      chatsApi.middleware,
      usersApi.middleware,
      subscriptionsApi.middleware,
      paymentApi.middleware,
      searchApi.middleware,
      firebaseApi.middleware,
      bugReportApi.middleware,
      appConfigApi.middleware,
      notificationsApi.middleware,
      supportApi.middleware,
    ) as never,
});

export function resetState() {}

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
